import { Link } from 'react-router-dom';
import { ShoppingBag, List, X } from '@phosphor-icons/react';
import { useState } from 'react';
import { useCart } from '@/context/CartContext';
import { motion, AnimatePresence } from 'framer-motion';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cartItemCount } = useCart();

  const navLinks = [
    { name: 'Shop', href: '/shop' },
    { name: 'Wall Art', href: '/category/Wall Art' },
    { name: 'Lighting', href: '/category/Decorative Lamps' },
    { name: 'Vases', href: '/category/Vases & Planters' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-nexa-border/50" data-testid="header">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Mobile menu button */}
          <button 
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <List size={24} />}
          </button>

          {/* Left nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.slice(0, 4).map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="text-sm font-medium tracking-wide text-nexa-charcoal hover:text-nexa-gold transition-colors"
                data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo">
            <h1 className="font-serif text-2xl md:text-3xl font-semibold tracking-tight text-nexa-charcoal">
              Nexaorbits
            </h1>
          </Link>

          {/* Right nav */}
          <div className="flex items-center gap-6">
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.slice(4).map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm font-medium tracking-wide text-nexa-charcoal hover:text-nexa-gold transition-colors"
                  data-testid={`nav-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            <Link 
              to="/cart" 
              className="relative p-2 hover:bg-nexa-stone rounded-full transition-colors"
              data-testid="cart-icon"
            >
              <ShoppingBag size={24} className="text-nexa-charcoal" />
              {cartItemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-nexa-gold text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium">
                  {cartItemCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t border-nexa-border"
          >
            <nav className="px-6 py-4 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="block text-base font-medium text-nexa-charcoal hover:text-nexa-gold transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
